import * as pdfjs from 'pdfjs-dist';
import pdfWorkerUrl from 'pdfjs-dist/build/pdf.worker.min.mjs?url';

import { pdfThumbnailScale } from './pdfThumbnailScale';

/**
 * Vignette de la 1re page d'un PDF (data URL JPEG), pour la bande du
 * visualiseur de la review : avec sept PDF sans aperçu, l'équipe CG ouvrait
 * chaque fichier pour savoir lequel supprimer (sprint du 07/10/2026,
 * SKIP-355). Rendu dans le worker pdf.js, mis en cache par URL pour la durée
 * de la session ; en cas d'échec (URL expirée, PDF illisible) on rend null et
 * l'appelant garde l'icône générique.
 */
pdfjs.GlobalWorkerOptions.workerSrc = pdfWorkerUrl;

const THUMBNAIL_BOX_PX = 128;
const cache = new Map<string, Promise<string | null>>();

const render = async (url: string): Promise<string | null> => {
  const task = pdfjs.getDocument({ url, disableAutoFetch: true, disableStream: false });
  try {
    const document_ = await task.promise;
    const page = await document_.getPage(1);
    try {
      const base = page.getViewport({ scale: 1 });
      const viewport = page.getViewport({ scale: pdfThumbnailScale(base.width, base.height, THUMBNAIL_BOX_PX) });
      const canvas = document.createElement('canvas');
      canvas.width = Math.ceil(viewport.width);
      canvas.height = Math.ceil(viewport.height);
      const context = canvas.getContext('2d');
      if (!context) return null;
      context.fillStyle = '#ffffff';
      context.fillRect(0, 0, canvas.width, canvas.height);
      await page.render({ canvasContext: context, viewport }).promise;
      const dataUrl = canvas.toDataURL('image/jpeg', 0.8);
      canvas.width = 0;
      canvas.height = 0;
      return dataUrl;
    } finally {
      page.cleanup();
      await document_.destroy();
    }
  } catch {
    return null;
  }
};

export const getPdfThumbnail = (url: string): Promise<string | null> => {
  let pending = cache.get(url);
  if (!pending) {
    pending = render(url);
    cache.set(url, pending);
  }
  return pending;
};
